export default __webpack_public_path__ + "static/Romie-Regular-Italic-05cfb23aff67fe65eff1ffcd6b693811.woff";